import notification from './notification';

/**
 * Displays a toast notification for with the error key
 * @param {any} reason reason for promise rejection/error
 */
export const showError = (reason: any) => {
  if (reason.errorKey) {
    notification.errorFromKey(reason.errorKey);
  }
};
